export interface SearchAvance {
  nbTot: number;
  nbCache: number;
  requestCacheList: string[];
  nbDisplay: number;
  requestDisplayList: string[];
  receiveList: string[];
}
